import React from "react";

function Icon({ iconName, className, ...props }) {
  const icons = {
    views: (
      <svg
        width="160"
        height="71"
        viewBox="0 0 200 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <rect
          x="0.695312"
          y="0.633789"
          width="198.737"
          height="69.7761"
          rx="34.8881"
          fill="#0190FE"
        />
        <path
          d="M20.6328 35.525C29.9043 55.4568 58.7094 55.4568 67.9809 35.525C58.6755 15.5932 29.9382 15.5763 20.6328 35.525ZM44.3069 46.1747C41.4802 46.1961 38.7647 45.0785 36.7717 43.0743C34.7789 41.0721 33.6777 38.3499 33.7183 35.525C33.7248 32.7067 34.8516 30.0057 36.853 28.0185C38.8521 26.0292 41.5613 24.918 44.3816 24.9266C47.2018 24.9352 49.9046 26.0612 51.891 28.0612C53.8796 30.0612 54.9914 32.7685 54.9807 35.587C54.9722 38.4053 53.8411 41.1062 51.8397 43.0913C49.8362 45.0764 47.1273 46.1854 44.3069 46.1747ZM51.5426 35.525C51.0509 45.4991 37.035 44.6764 37.1401 35.525C37.0481 26.3113 51.0659 25.6084 51.5426 35.525Z"
          fill="white"
        />
        <path
          d="M77.9492 29.8087L83.0518 25.8345H85.6463V41.7963H82.1653V30.5215L79.7438 32.3575L77.9492 29.8087Z"
          fill="white"
        />
        <path
          d="M94.7858 42.0555C92.6886 42.0555 91.0886 41.2779 89.9427 39.7444C88.8184 38.2108 88.2562 36.2237 88.2562 33.8046C88.2562 31.3855 88.8184 29.3984 89.9427 27.8648C91.0886 26.3313 92.6886 25.5537 94.7858 25.5537C96.9047 25.5537 98.5263 26.3313 99.6505 27.8648C100.796 29.3984 101.359 31.3855 101.359 33.8046C101.359 36.2237 100.796 38.2108 99.6505 39.7444C98.5263 41.2779 96.9047 42.0555 94.7858 42.0555ZM97.8128 33.8046C97.8128 32.3575 97.5533 31.1911 97.0344 30.2839C96.5371 29.3552 95.7804 28.9016 94.8074 28.9016C93.8129 28.9016 93.0561 29.3552 92.5588 30.2839C92.0615 31.1911 91.8021 32.3575 91.8021 33.8046C91.8021 36.7421 92.7967 38.7076 94.8074 38.7076C96.8182 38.7076 97.8128 36.7421 97.8128 33.8046Z"
          fill="white"
        />
        <path
          d="M109.735 42.0555C107.638 42.0555 106.038 41.2779 104.892 39.7444C103.767 38.2108 103.205 36.2237 103.205 33.8046C103.205 31.3855 103.767 29.3984 104.892 27.8648C106.038 26.3313 107.638 25.5537 109.735 25.5537C111.854 25.5537 113.475 26.3313 114.6 27.8648C115.745 29.3984 116.308 31.3855 116.308 33.8046C116.308 36.2237 115.745 38.2108 114.6 39.7444C113.475 41.2779 111.854 42.0555 109.735 42.0555ZM112.762 33.8046C112.762 32.3575 112.502 31.1911 111.983 30.2839C111.486 29.3552 110.729 28.9016 109.756 28.9016C108.762 28.9016 108.005 29.3552 107.508 30.2839C107.011 31.1911 106.751 32.3575 106.751 33.8046C106.751 36.7421 107.746 38.7076 109.756 38.7076C111.767 38.7076 112.762 36.7421 112.762 33.8046Z"
          fill="white"
        />
        <path
          d="M119.867 38.3836C121.078 38.3836 121.943 39.334 121.943 40.6083C121.943 42.3147 120.754 43.9562 118.375 45.4898L117.402 44.1938C117.857 43.8482 118.159 43.589 118.354 43.4378C118.721 43.157 119.37 42.5091 119.629 42.0555H119.565C118.678 42.0555 117.9 41.2563 117.9 40.306C117.9 39.2044 118.808 38.3836 119.867 38.3836Z"
          fill="white"
        />
        <path
          d="M130.068 42.0555C127.971 42.0555 126.371 41.2779 125.225 39.7444C124.1 38.2108 123.538 36.2237 123.538 33.8046C123.538 31.3855 124.1 29.3984 125.225 27.8648C126.371 26.3313 127.971 25.5537 130.068 25.5537C132.187 25.5537 133.808 26.3313 134.933 27.8648C136.079 29.3984 136.641 31.3855 136.641 33.8046C136.641 36.2237 136.079 38.2108 134.933 39.7444C133.808 41.2779 132.187 42.0555 130.068 42.0555ZM133.095 33.8046C133.095 32.3575 132.835 31.1911 132.316 30.2839C131.819 29.3552 131.062 28.9016 130.09 28.9016C129.095 28.9016 128.338 29.3552 127.841 30.2839C127.344 31.1911 127.084 32.3575 127.084 33.8046C127.084 36.7421 128.079 38.7076 130.09 38.7076C132.1 38.7076 133.095 36.7421 133.095 33.8046Z"
          fill="white"
        />
        <path
          d="M145.017 42.0555C142.92 42.0555 141.32 41.2779 140.174 39.7444C139.049 38.2108 138.487 36.2237 138.487 33.8046C138.487 31.3855 139.049 29.3984 140.174 27.8648C141.32 26.3313 142.92 25.5537 145.017 25.5537C147.136 25.5537 148.757 26.3313 149.882 27.8648C151.028 29.3984 151.59 31.3855 151.59 33.8046C151.59 36.2237 151.028 38.2108 149.882 39.7444C148.757 41.2779 147.136 42.0555 145.017 42.0555ZM148.044 33.8046C148.044 32.3575 147.784 31.1911 147.265 30.2839C146.768 29.3552 146.011 28.9016 145.038 28.9016C144.044 28.9016 143.287 29.3552 142.79 30.2839C142.293 31.1911 142.033 32.3575 142.033 33.8046C142.033 36.7421 143.028 38.7076 145.038 38.7076C147.049 38.7076 148.044 36.7421 148.044 33.8046Z"
          fill="white"
        />
        <path
          d="M159.966 42.0555C157.869 42.0555 156.269 41.2779 155.123 39.7444C153.998 38.2108 153.436 36.2237 153.436 33.8046C153.436 31.3855 153.998 29.3984 155.123 27.8648C156.269 26.3313 157.869 25.5537 159.966 25.5537C162.085 25.5537 163.706 26.3313 164.831 27.8648C165.976 29.3984 166.539 31.3855 166.539 33.8046C166.539 36.2237 165.976 38.2108 164.831 39.7444C163.706 41.2779 162.085 42.0555 159.966 42.0555ZM162.993 33.8046C162.993 32.3575 162.733 31.1911 162.214 30.2839C161.717 29.3552 160.96 28.9016 159.987 28.9016C158.993 28.9016 158.236 29.3552 157.739 30.2839C157.242 31.1911 156.982 32.3575 156.982 33.8046C156.982 36.7421 157.977 38.7076 159.987 38.7076C161.998 38.7076 162.993 36.7421 162.993 33.8046Z"
          fill="white"
        />
        <path
          d="M175.434 32.703H179.498V35.8781H175.434V39.9604L172.255 40.0036V35.8781H168.147V32.703H172.255V28.6208H175.434V32.703Z"
          fill="white"
        />
      </svg>
    ),
    growth: (
      <svg
        width="64"
        height="64"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <rect width="79.9291" height="79.9291" rx="39.9646" fill="#1C9C1C" />
        <path
          d="M55.2449 27.6563V24.456C42.2939 37.577 23.7291 39.9324 22.9361 40.0348H22.7924C22.4612 40.0543 22.136 39.9382 21.8883 39.7119C21.6406 39.4856 21.4908 39.1678 21.4717 38.8283C21.4527 38.4888 21.566 38.1554 21.7867 37.9016C22.0075 37.6477 22.3176 37.4941 22.6488 37.4746C22.8361 37.4746 40.9264 35.132 53.2841 22.8175H50.5428C50.2116 22.8175 49.8939 22.6826 49.6597 22.4426C49.4255 22.2025 49.2939 21.8769 49.2939 21.5374C49.2939 21.1979 49.4255 20.8723 49.6597 20.6323C49.8939 20.3922 50.2116 20.2573 50.5428 20.2573H56.4938C56.825 20.2573 57.1427 20.3922 57.3769 20.6323C57.6111 20.8723 57.7427 21.1979 57.7427 21.5374V27.6435C57.7427 27.983 57.6111 28.3086 57.3769 28.5486C57.1427 28.7887 56.825 28.9236 56.4938 28.9236C56.1626 28.9236 55.8449 28.7887 55.6107 28.5486C55.3765 28.3086 55.2449 27.983 55.2449 27.6435V27.6563ZM58.6981 30.9141L52.7471 30.9141C52.4159 30.9141 52.0982 31.049 51.864 31.289C51.6298 31.5291 51.4982 31.8547 51.4982 32.1942V58.9162C51.4982 59.2557 51.6298 59.5813 51.864 59.8214C52.0982 60.0614 52.4159 60.1963 52.7471 60.1963H58.6981C59.0293 60.1963 59.347 60.0614 59.5812 59.8214C59.8154 59.5813 59.947 59.2557 59.947 58.9162V32.1942C59.947 31.8547 59.8154 31.5291 59.5812 31.289C59.347 31.049 59.0293 30.9141 58.6981 30.9141ZM48.1949 37.481H42.2439C41.9127 37.481 41.595 37.6159 41.3608 37.8559C41.1266 38.096 40.995 38.4216 40.995 38.7611V58.9162C40.995 59.2557 41.1266 59.5813 41.3608 59.8214C41.595 60.0614 41.9127 60.1963 42.2439 60.1963H48.1949C48.3589 60.1963 48.5213 60.1632 48.6728 60.0988C48.8244 60.0345 48.962 59.9402 49.078 59.8214C49.194 59.7025 49.286 59.5614 49.3487 59.4061C49.4115 59.2508 49.4438 59.0843 49.4438 58.9162V38.7611C49.4438 38.593 49.4115 38.4265 49.3487 38.2712C49.286 38.1159 49.194 37.9748 49.078 37.8559C48.962 37.7371 48.8244 37.6428 48.6728 37.5784C48.5213 37.5141 48.3589 37.481 48.1949 37.481ZM37.6855 40.8349H31.7345C31.4033 40.8349 31.0856 40.9697 30.8514 41.2098C30.6172 41.4498 30.4856 41.7754 30.4856 42.1149L30.4856 58.9162C30.4856 59.2557 30.6172 59.5813 30.8514 59.8214C31.0856 60.0614 31.4033 60.1963 31.7345 60.1963H37.6855C38.0167 60.1963 38.3344 60.0614 38.5686 59.8214C38.8028 59.5813 38.9344 59.2557 38.9344 58.9162V42.1149C38.9344 41.7754 38.8028 41.4498 38.5686 41.2098C38.3344 40.9697 38.0167 40.8349 37.6855 40.8349ZM27.1823 44.8608H21.2313C20.9001 44.8608 20.5824 44.9956 20.3482 45.2357C20.114 45.4757 19.9824 45.8013 19.9824 46.1408V58.9418C19.9824 59.2813 20.114 59.6069 20.3482 59.847C20.5824 60.087 20.9001 60.2219 21.2313 60.2219H27.1823C27.5135 60.2219 27.8312 60.087 28.0654 59.847C28.2996 59.6069 28.4312 59.2813 28.4312 58.9418L28.4312 46.1408C28.4312 45.8013 28.2996 45.4757 28.0654 45.2357C27.8312 44.9956 27.5135 44.8608 27.1823 44.8608Z"
          fill="white"
        />
      </svg>
    ),
    likes: (
      <svg
        width="120"
        height="54"
        viewBox="0 0 149 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <rect
          x="0.330078"
          y="0.609375"
          width="148.489"
          height="53.3893"
          rx="26.6946"
          fill="#F0B41D"
        />
        <path
          d="M26.3953 22.4112H22.563C21.3412 22.4112 20.3516 23.4208 20.3516 24.6672V38.1301C20.3516 39.3764 21.3426 40.386 22.5644 40.3874H26.3923C27.0379 40.3874 27.6183 40.1136 28.0275 39.673L28.0289 39.6716C28.4026 39.268 28.632 38.7262 28.632 38.1301V24.6672C28.632 24.0725 28.4041 23.5335 28.0332 23.1314L28.0318 23.13C27.6226 22.6865 27.0422 22.4112 26.3953 22.4112ZM35.9655 13.9565C35.2364 13.9722 34.5625 14.3544 34.169 14.9747L29.0229 23.0914H28.7978L28.8006 23.0928C29.0936 23.5448 29.2635 24.0853 29.2635 24.6671V38.13C29.2635 38.4494 29.2111 38.7575 29.1163 39.0441L29.3371 39.0483L29.5183 39.4148C29.8893 40.1635 30.6481 40.6355 31.4777 40.6369L44.6172 40.6512C45.4142 40.6498 46.1603 40.2106 46.5411 39.4975L46.6119 39.3649C47.6864 37.3457 48.9592 34.9616 49.3797 32.1565C49.7973 29.3787 49.3556 26.3171 48.9818 23.6774L48.9691 23.6004V23.5989C48.8148 22.5123 47.8917 21.7038 46.8016 21.7024L41.463 21.6938L42.0223 18.9872C42.1313 18.4582 42.0435 17.912 41.7773 17.4429L40.4267 15.0714C40.0374 14.387 39.314 13.9634 38.531 13.9606L35.9655 13.9565Z"
          fill="white"
        />
        <path
          d="M64.6515 29.7452L62.3744 32.1583H67.1914V34.5193H58.7485V32.384L62.7773 28.2001C63.1626 27.8009 63.4429 27.5231 63.6005 27.3321C63.7582 27.1412 63.9333 26.8634 64.126 26.5162C64.3187 26.169 64.4238 25.8391 64.4238 25.5267C64.4238 24.5545 63.6706 23.8774 62.6371 23.8774C61.7263 23.8774 60.7629 24.3462 59.7294 25.301L58.3105 23.4608C59.6593 22.124 61.1833 21.4644 62.8473 21.4644C64.0735 21.4644 65.0894 21.8289 65.8777 22.5754C66.6659 23.3045 67.0688 24.242 67.0688 25.3878C67.0688 26.6204 66.263 28.0786 64.6515 29.7452Z"
          fill="white"
        />
        <path
          d="M73.3411 26.2558C74.5672 26.2558 75.6007 26.6377 76.4415 27.4016C77.2823 28.1654 77.7027 29.155 77.7027 30.3875C77.7027 31.6375 77.2648 32.6791 76.3714 33.495C75.4781 34.311 74.322 34.7276 72.8681 34.7276C71.3092 34.7276 69.8553 34.2589 68.524 33.3041L69.5575 31.2556C70.6611 32.002 71.712 32.3666 72.7455 32.3666C74.1994 32.3666 75.0927 31.4986 75.0927 30.3875C75.0927 29.2765 74.1644 28.4606 72.9032 28.4606C72.0799 28.4606 71.3792 28.7383 70.7662 29.3112L69.2597 28.1133L69.9604 21.69L76.8093 21.69V24.051H71.8872L71.6069 26.5683C72.15 26.36 72.728 26.2558 73.3411 26.2558Z"
          fill="white"
        />
        <path
          d="M80.591 32.002C81.4843 32.002 82.15 32.7138 82.15 33.6686C82.15 34.9186 81.2566 36.1338 79.4524 37.3143L78.7167 36.3421C79.6451 35.6477 80.2056 35.1095 80.4158 34.7103H80.3633C79.6801 34.7103 79.1021 34.12 79.1021 33.4256C79.1021 32.6097 79.7677 32.002 80.591 32.002Z"
          fill="white"
        />
        <path
          d="M88.7191 34.7276C87.563 34.7276 86.5821 34.4151 85.7763 33.7902C84.1648 32.5402 83.4816 30.5438 83.4816 28.096C83.4816 26.8634 83.6568 25.7697 84.0246 24.7975C84.7428 22.8532 86.4069 21.4644 88.7191 21.4644C92.3275 21.4644 93.9565 24.5545 93.9565 28.096C93.9565 31.6375 92.3275 34.7276 88.7191 34.7276ZM91.3816 28.096C91.3816 26.8634 91.1539 25.8391 90.716 25.0579C90.278 24.2767 89.6124 23.8774 88.7191 23.8774C87.8432 23.8774 87.1776 24.2767 86.7397 25.0579C86.3018 25.8391 86.0741 26.8634 86.0741 28.096C86.0741 30.5959 86.9499 32.3145 88.7191 32.3145C90.4882 32.3145 91.3816 30.5959 91.3816 28.096Z"
          fill="white"
        />
        <path
          d="M100.779 34.7276C99.6227 34.7276 98.6418 34.4151 97.836 33.7902C96.2245 32.5402 95.5413 30.5438 95.5413 28.096C95.5413 26.8634 95.7165 25.7697 96.0844 24.7975C96.8025 22.8532 98.4666 21.4644 100.779 21.4644C104.387 21.4644 106.016 24.5545 106.016 28.096C106.016 31.6375 104.387 34.7276 100.779 34.7276ZM103.441 28.096C103.441 26.8634 103.214 25.8391 102.776 25.0579C102.338 24.2767 101.672 23.8774 100.779 23.8774C99.903 23.8774 99.2373 24.2767 98.7994 25.0579C98.3615 25.8391 98.1338 26.8634 98.1338 28.096C98.1338 30.5959 99.0096 32.3145 100.779 32.3145C102.548 32.3145 103.441 30.5959 103.441 28.096Z"
          fill="white"
        />
        <path
          d="M112.838 34.7276C111.682 34.7276 110.701 34.4151 109.896 33.7902C108.284 32.5402 107.601 30.5438 107.601 28.096C107.601 26.8634 107.776 25.7697 108.144 24.7975C108.862 22.8532 110.526 21.4644 112.838 21.4644C116.447 21.4644 118.076 24.5545 118.076 28.096C118.076 31.6375 116.447 34.7276 112.838 34.7276ZM115.501 28.096C115.501 26.8634 115.273 25.8391 114.835 25.0579C114.397 24.2767 113.732 23.8774 112.838 23.8774C111.963 23.8774 111.297 24.2767 110.859 25.0579C110.421 25.8391 110.193 26.8634 110.193 28.096C110.193 30.5959 111.069 32.3145 112.838 32.3145C114.608 32.3145 115.501 30.5959 115.501 28.096Z"
          fill="white"
        />
        <path
          d="M125.091 27.3321H128.384V29.6411H125.091V32.9048L122.779 32.9395V29.6411H119.451V27.3321H122.779V24.051H125.091V27.3321Z"
          fill="white"
        />
      </svg>
    ),
    mic: (
      <svg
        width="16"
        height="32"
        viewBox="0 0 21 32"
        fill="#FF4400"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M20.4587 15.3699C20.4587 14.9288 20.1001 14.5703 19.6591 14.5703C19.2181 14.5703 18.8596 14.9288 18.8596 15.3699C18.8596 20.1283 14.9893 24.0001 10.2293 24.0001C5.47085 24.0001 1.59909 20.1299 1.59909 15.3699C1.59909 14.9288 1.24056 14.5703 0.799544 14.5703C0.358527 14.5703 0 14.9288 0 15.3699C0 20.7401 4.16285 25.1476 9.42979 25.5585V27.1996H7.02962C5.70653 27.1996 4.62945 28.2767 4.62945 29.5998C4.62945 30.9228 5.70653 31.9999 7.02962 31.9999H13.4306C14.7537 31.9999 15.8308 30.9228 15.8308 29.5998C15.8308 28.2767 14.7537 27.1996 13.4306 27.1996H11.0304V25.5585C16.2973 25.1475 20.4602 20.7401 20.4602 15.3699H20.4587Z"
          fill="#FF4400"
        />
        <path
          d="M13.4294 15.199C12.9884 15.199 12.6298 14.8405 12.6298 14.3995C12.6298 13.9585 12.9884 13.5999 13.4294 13.5999H17.0296V11.9993H13.4294C12.9884 11.9993 12.6298 11.6408 12.6298 11.1998C12.6298 10.7588 12.9884 10.4002 13.4294 10.4002H17.0296V8.7996H13.4294C12.9884 8.7996 12.6298 8.44107 12.6298 8.00005C12.6298 7.55903 12.9884 7.20051 13.4294 7.20051H17.0296V6.79997C17.0296 3.04971 13.9784 0 10.2297 0C6.4794 0 3.42969 3.05121 3.42969 6.79997V7.20051H7.02994C7.47096 7.20051 7.82949 7.55903 7.82949 8.00005C7.82949 8.44107 7.47096 8.7996 7.02994 8.7996H3.42969V10.4002H7.02994C7.47096 10.4002 7.82949 10.7587 7.82949 11.1998C7.82949 11.6408 7.47096 11.9993 7.02994 11.9993H3.42969V13.5999H7.02994C7.47096 13.5999 7.82949 13.9585 7.82949 14.3995C7.82949 14.8405 7.47096 15.199 7.02994 15.199H3.42969V15.37C3.42969 19.1203 6.4809 22.17 10.2297 22.17C13.9799 22.17 17.0296 19.1188 17.0296 15.37V15.199H13.4294Z"
          fill="#FF4400"
        />
      </svg>
    ),
    video: (
      <svg
        width="24"
        height="32"
        viewBox="0 0 34 32"
        fill="#33A1FF"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M29.7231 9.22532H27.1202L26.215 7.36447C25.799 6.50993 24.9164 5.95898 23.9663 5.95898H16.0394C15.0893 5.95898 14.2066 6.50993 13.7906 7.36447L12.8855 9.22532H10.6648V8.19651C10.6648 7.56686 10.1532 7.06088 9.52354 7.06088H6.4877C5.86367 7.06088 5.35207 7.56686 5.35207 8.19651V9.22532H4.00843C1.79902 9.22532 0 11.0243 0 13.2394V27.9857C0 30.1951 1.79902 31.9997 4.00843 31.9997H29.7231C31.9325 31.9997 33.7316 30.1951 33.7316 27.9857V13.2394C33.7316 11.0243 31.9325 9.22532 29.7231 9.22532ZM3.71609 14.1782C3.71609 13.498 4.26704 12.9414 4.95292 12.9414H7.42656C8.10682 12.9414 8.66339 13.498 8.66339 14.1782V16.6575C8.66339 17.3378 8.10682 17.8943 7.42656 17.8943H4.95292C4.26704 17.8943 3.71609 17.3378 3.71609 16.6575V14.1782ZM20.0028 29.1326C15.3085 29.1326 11.4912 25.3097 11.4912 20.6097C11.4912 15.9154 15.3085 12.0925 20.0028 12.0925C24.6971 12.0925 28.5144 15.9154 28.5144 20.6097C28.5144 25.3097 24.6971 29.1326 20.0028 29.1326ZM6.4877 8.18527H9.52354L9.54041 9.22532H6.48208L6.4877 8.18527Z"
          fill="#33A1FF"
        />
        <path
          d="M20.0024 13.2168C15.9265 13.2168 12.6152 16.5337 12.6152 20.6096C12.6152 24.6911 15.9265 28.0081 20.0024 28.0081C24.0783 28.0081 27.3897 24.6911 27.3897 20.6096C27.3897 16.5337 24.0783 13.2168 20.0024 13.2168ZM20.0024 25.7087C17.1971 25.7087 14.9146 23.4206 14.9146 20.6096C14.9146 17.8043 17.1971 15.5162 20.0024 15.5162C22.8078 15.5162 25.0903 17.8043 25.0903 20.6096C25.0903 23.4206 22.8078 25.7087 20.0024 25.7087Z"
          fill="#33A1FF"
        />
        <path
          d="M4.95228 16.7706H7.42593C7.48777 16.7706 7.53837 16.72 7.53837 16.6581V14.1788C7.53837 14.117 7.48777 14.0664 7.42593 14.0664H4.95228C4.89044 14.0664 4.83984 14.117 4.83984 14.1788V16.6581C4.83984 16.72 4.89044 16.7706 4.95228 16.7706Z"
          fill="#33A1FF"
        />
        <path
          d="M20.6592 18.1083C20.4399 17.889 20.0857 17.889 19.8665 18.1083L17.8988 20.076C17.6796 20.2952 17.6796 20.6494 17.8988 20.8687C18.0113 20.9811 18.1518 21.0317 18.298 21.0317C18.4441 21.0317 18.5847 20.9755 18.6971 20.8687L20.6648 18.901C20.8841 18.6873 20.8841 18.3275 20.6592 18.1083Z"
          fill="#33A1FF"
        />
        <path
          d="M21.3138 20.3456L19.3461 22.3133C19.1268 22.5325 19.1268 22.8867 19.3461 23.106C19.4585 23.2184 19.5991 23.269 19.7452 23.269C19.8914 23.269 20.032 23.2128 20.1444 23.106L22.1121 21.1383C22.3313 20.919 22.3313 20.5648 22.1121 20.3456C21.8872 20.1263 21.533 20.1263 21.3138 20.3456Z"
          fill="#33A1FF"
        />
        <path
          d="M20.2673 4.17709C20.5765 4.17709 20.8295 3.9241 20.8295 3.6149V0.562193C20.8295 0.252987 20.5765 0 20.2673 0C19.9581 0 19.7051 0.252987 19.7051 0.562193V3.6149C19.7051 3.9241 19.9581 4.17709 20.2673 4.17709Z"
          fill="#33A1FF"
        />
        <path
          d="M16.269 4.45251C16.3814 4.59868 16.5444 4.67177 16.7131 4.67177C16.8312 4.67177 16.9548 4.63241 17.056 4.55371C17.3034 4.36256 17.3484 4.014 17.1572 3.76664L15.7742 1.97886C15.5831 1.7315 15.2345 1.68652 14.9872 1.87767C14.7398 2.06882 14.6948 2.41737 14.886 2.66474L16.269 4.45251Z"
          fill="#33A1FF"
        />
        <path
          d="M23.8203 4.67177C23.989 4.67177 24.1577 4.59868 24.2645 4.45251L25.6475 2.66474C25.8386 2.41737 25.7936 2.06319 25.5463 1.87767C25.2989 1.68652 24.9447 1.7315 24.7592 1.97886L23.3762 3.76664C23.1851 4.014 23.23 4.36818 23.4774 4.55371C23.5786 4.63241 23.6967 4.67177 23.8203 4.67177Z"
          fill="#33A1FF"
        />
      </svg>
    ),
    acoustic: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 32 32"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M26.668 16.1779V15.1107C26.668 8.59032 21.4664 3.28433 14.9868 3.11553C14.8806 3.1124 14.7743 3.11084 14.6681 3.11084C14.5071 3.11084 14.3493 3.11396 14.19 3.12021C7.78357 3.37021 2.66797 8.64381 2.66797 15.111V22.3922C7.72717 23.225 11.8836 23.6 16.1072 23.5078C16.7712 19.2546 20.4508 15.9998 24.89 15.9998C25.4993 15.9998 26.093 16.0607 26.668 16.1779Z"
          fill="#28A745"
        />
        <path
          d="M16.0093 25.2877C11.6421 25.3736 7.33408 24.9736 2.09688 24.1001C0.995319 23.9158 0 24.7579 0 25.847C0 26.6908 0.6 27.4079 1.41876 27.5517C7.39076 28.5955 12.0752 29.0298 16.9296 28.8501C16.3905 27.7689 16.0655 26.5642 16.0093 25.2877Z"
          fill="#28A745"
        />
        <path
          d="M14.6668 1.33282C14.5184 1.33282 14.3715 1.33595 14.2246 1.34064C13.784 1.3547 13.3496 1.38907 12.9199 1.4422C13.0762 0.62188 13.7996 0 14.6668 0C15.534 0 16.2559 0.62188 16.4121 1.4422C16.0168 1.3922 15.6168 1.35939 15.2121 1.34376C15.0309 1.33751 14.8496 1.33282 14.6668 1.33282Z"
          fill="#28A745"
        />
        <path
          d="M16.3937 30.645C15.2422 30.6763 14.0953 30.6731 12.9375 30.6372C13.125 31.4184 13.8281 31.9997 14.6672 31.9997C15.5031 31.9997 16.2031 31.4231 16.3937 30.645Z"
          fill="#28A745"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.7773 24.8891C17.7773 20.961 20.9601 17.7783 24.8881 17.7783C28.8147 17.7783 31.9989 20.9611 31.9989 24.8891C31.9989 28.8157 28.8146 31.9999 24.8881 31.9999C20.96 31.9999 17.7773 28.8156 17.7773 24.8891ZM28.0305 23.0032C28.3774 22.6563 28.3774 22.0938 28.0305 21.7454C27.6837 21.3985 27.1212 21.3985 26.7743 21.7454L24.8884 23.6313L23.0025 21.7454C22.6556 21.3985 22.0931 21.3985 21.7462 21.7454C21.3978 22.0938 21.3978 22.6563 21.7462 23.0032L23.6306 24.8891L21.7462 26.775C21.3978 27.1219 21.3978 27.6844 21.7462 28.0313C22.0931 28.3782 22.6556 28.3782 23.0025 28.0313L24.8884 26.1454L26.7743 28.0313C27.1212 28.3782 27.6837 28.3782 28.0305 28.0313C28.3774 27.6844 28.3774 27.1219 28.0305 26.775L26.1446 24.8891L28.0305 23.0032Z"
          fill="#28A745"
        />
      </svg>
    ),
    lighting: (
      <svg
        width="24"
        height="32"
        viewBox="0 0 24 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M11.9945 16.963C14.7317 16.963 16.9616 14.733 16.9616 11.9959C16.9616 9.25888 14.7315 7.02881 11.9945 7.02881C9.25742 7.02881 7.02734 9.25888 7.02734 11.9959C7.02734 14.733 9.25742 16.963 11.9945 16.963ZM11.9945 9.89099C13.1558 9.89099 14.0991 10.8343 14.0991 11.9956C14.0991 13.157 13.1558 14.1003 11.9945 14.1003C10.8331 14.1003 9.88981 13.157 9.88981 11.9956C9.88981 10.8343 10.8331 9.89099 11.9945 9.89099Z"
          fill="#FFC107"
        />
        <path
          d="M23.7021 4.72727C23.5222 4.63458 23.3041 4.64548 23.1405 4.75998L19.2039 7.44807V5.33249C19.2039 5.0326 18.9639 4.78724 18.6586 4.78724H16.4231L19.1112 0.850601C19.2257 0.687025 19.2366 0.468907 19.1439 0.288982C19.0457 0.114501 18.8604 0 18.6586 0H5.33247C5.13073 0 4.94534 0.114501 4.84721 0.288982C4.75452 0.468914 4.76542 0.687008 4.87992 0.850601L7.56801 4.78724H5.33249C5.02715 4.78724 4.78724 5.0326 4.78724 5.33249V7.44807L0.850601 4.75998C0.687025 4.64548 0.468907 4.63457 0.288982 4.72727C0.114501 4.81996 0 5.00535 0 5.21253V18.5387C0 18.7404 0.114501 18.9258 0.288982 19.0185C0.370772 19.0621 0.458012 19.0839 0.545252 19.0839C0.654303 19.0839 0.757903 19.0512 0.850594 18.9912L4.78723 16.2977V18.6586C4.78723 18.9585 5.02714 19.2039 5.33248 19.2039H7.568L4.87991 23.1405C4.76541 23.3041 4.7545 23.5222 4.8472 23.7021C4.94535 23.8766 5.13073 23.9911 5.33247 23.9911H9.38915V31.0792C9.38915 31.3791 9.63451 31.6245 9.9344 31.6245H14.1164C14.4162 31.6245 14.6616 31.3791 14.6616 31.0792V23.9911H18.6583C18.86 23.9911 19.0454 23.8766 19.1435 23.7021C19.2362 23.5222 19.2253 23.3041 19.1108 23.1405L16.4227 19.2039H18.6582C18.9636 19.2039 19.2035 18.9585 19.2035 18.6586V16.2977L23.1401 18.9912C23.2328 19.0512 23.3364 19.0839 23.4455 19.0839C23.5327 19.0839 23.62 19.0621 23.7017 19.0185C23.8762 18.9258 23.9907 18.7404 23.9907 18.5387V5.21253C23.9907 5.00534 23.8762 4.81995 23.7017 4.72727H23.7021ZM13.5714 30.534H10.4798V23.991H13.5714V30.534ZM18.1135 18.1131H5.8782V5.8778H18.1135V18.1131Z"
          fill="#FFC107"
        />
      </svg>
    ),
    check: (
      <svg
        width="18"
        height="12"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M1 6L6.33333 11L17 1"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    plus: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M9.57265 6.44776H16V9.51812H9.57265V15.9659L6.49573 16V9.51812H0V6.44776H6.49573V0H9.57265V6.44776Z"
          fill="black"
        />
      </svg>
    ),
    phone: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.04573 4.83824C-0.0490604 3.48983 -0.0891136 3.58997 0.898857 2.49386C3.53299 -0.424597 5.07785 -0.596817 6.19377 1.02262C6.20445 1.03864 6.2138 1.05066 6.22582 1.06534C10.2257 6.03442 9.9974 5.20151 6.76918 10.2813C6.62499 10.5083 6.61565 10.7766 6.74515 11.0129C8.45407 14.1276 9.87326 15.5469 12.9868 17.2544C13.2231 17.3839 13.4915 17.3759 13.7184 17.2304C18.7984 14.0022 17.9654 13.774 22.9346 17.7738C22.9493 17.7858 22.9627 17.7951 22.9774 17.8058C24.5968 18.9219 24.4246 20.4679 21.5061 23.1006C20.41 24.0885 20.5101 24.0498 19.1616 23.9537C10.6625 23.3529 0.646586 13.3375 0.04573 4.83824Z"
          fill="#1C1C1C"
        />
      </svg>
    ),
    email: (
      <svg
        width="24"
        height="17"
        viewBox="0 0 24 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M11.4858 7.90508L1.30293 0.331513C1.68007 0.119013 2.11722 0 2.5715 0H21.4286C21.8829 0 22.3201 0.119 22.6972 0.331513L12.5144 7.90508C12.2143 8.13458 11.7858 8.12608 11.4858 7.90508ZM23.8201 1.62351L13.5429 9.26508C13.0887 9.60508 12.5401 9.77508 12.0001 9.77508C11.4515 9.77508 10.9115 9.60508 10.4572 9.26508L0.18 1.62351C0.06 1.91251 0 2.22703 0 2.55V14.45C0 15.8525 1.15716 17 2.57143 17H21.4286C22.8428 17 24 15.8525 24 14.45V2.55C24 2.227 23.9401 1.91249 23.8201 1.62351Z"
          fill="#1C1C1C"
        />
      </svg>
    ),
    address: (
      <svg
        width="19"
        height="24"
        viewBox="0 0 19 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M9.49989 5.11758C7.16356 5.11758 5.28273 7.00649 5.28273 9.2916C5.28273 11.5767 7.16188 13.4163 9.49989 13.4163C11.8362 13.4163 13.7675 11.5783 13.7675 9.2916C13.7675 7.00649 11.8362 5.11758 9.49989 5.11758ZM9.49989 14.7576C6.40049 14.7576 3.91131 12.3229 3.91131 9.2916C3.91131 6.26028 6.40062 3.77632 9.49989 3.77632C12.5992 3.77632 15.1388 6.26032 15.1388 9.2916C15.1388 12.3229 12.5991 14.7576 9.49989 14.7576ZM9.49989 0C4.26759 0 0 4.17402 0 9.2916C0 12.0239 1.32111 15.7509 3.40366 18.9317C5.43578 22.0618 7.77194 24 9.49998 24C11.4817 24 13.8683 22.0124 15.8502 18.6834C17.7814 15.5533 19 11.8756 19 9.29328C19 4.17571 14.7324 0.00168329 9.50011 0.00168329L9.49989 0Z"
          fill="black"
        />
      </svg>
    ),
    instagram: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M0 16.9231C0 20.8305 3.16954 24 7.07692 24H16.9231C20.8305 24 24 20.8305 24 16.9231V7.07692C24 3.16954 20.8305 0 16.9231 0H7.07692C3.16954 0 0 3.16954 0 7.07692V16.9231ZM18.4615 4.30769C19.3233 4.30769 20 4.98437 20 5.84615C20 6.70794 19.3233 7.38462 18.4615 7.38462C17.5998 7.38462 16.9231 6.70794 16.9231 5.84615C16.9231 4.98437 17.5998 4.30769 18.4615 4.30769ZM12 6.15385C15.2308 6.15385 17.8462 8.76923 17.8462 12C17.8462 15.2308 15.2308 17.8462 12 17.8462C8.76923 17.8462 6.15385 15.2308 6.15385 12C6.15385 8.76923 8.76923 6.15385 12 6.15385Z"
          fill="black"
        />
        <path
          d="M16 12C16 14.2092 14.2091 16 12 16C9.79086 16 8 14.2092 8 12C8 9.79088 9.79086 8.00002 12 8.00002C14.2091 8.00002 16 9.79088 16 12Z"
          fill="black"
        />
      </svg>
    ),
    facebook: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <rect width="24" height="24" rx="6" fill="black" />
        <path
          d="M7 10.2222V13.7778H9.72727V20H13.3636V13.7778H16.0909L17 10.2222H13.3636V8.44444C13.3636 8.2087 13.4594 7.9826 13.6299 7.81591C13.8004 7.64921 14.0316 7.55556 14.2727 7.55556H17V4H14.2727C13.0672 4 11.911 4.46825 11.0586 5.30175C10.2062 6.13524 9.72727 7.2657 9.72727 8.44444V10.2222H7Z"
          fill="white"
        />
      </svg>
    ),
    chevronRight: (
      <svg
        width="19"
        height="10"
        viewBox="0 0 19 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M1.5 5H17.5M17.5 5L12.9286 9M17.5 5L12.9286 1"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    // Add more icons here
  };

  return icons[iconName] || <span>?</span>;
}

export default Icon;
